import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a521402"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "customer" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-10" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  class: "col-1",
  style: {"text-align":"end"}
}
const _hoisted_7 = {
  class: "col-1",
  style: {"text-align":"end"}
}
const _hoisted_8 = { class: "user-header" }
const _hoisted_9 = { class: "form-group row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Region", -1))
const _hoisted_11 = { class: "col-sm-4" }
const _hoisted_12 = { class: "form-group row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Company Name", -1))
const _hoisted_14 = { class: "col-sm-4" }
const _hoisted_15 = { class: "form-group row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Branch Name", -1))
const _hoisted_17 = { class: "col-sm-4" }
const _hoisted_18 = { class: "report-items" }
const _hoisted_19 = {
  class: "nav nav-tabs mb-3",
  role: "tablist"
}
const _hoisted_20 = { class: "nav-item" }
const _hoisted_21 = { class: "nav-item" }
const _hoisted_22 = { class: "nav-item" }
const _hoisted_23 = { class: "nav-item" }
const _hoisted_24 = { class: "nav-item" }
const _hoisted_25 = { class: "nav-item" }
const _hoisted_26 = { class: "nav-item" }
const _hoisted_27 = { class: "nav-item" }
const _hoisted_28 = { class: "navbar fixed-bottom navbar-dark bg-primary" }
const _hoisted_29 = { class: "container-fluid" }
const _hoisted_30 = {
  id: "status-bar-actions",
  style: {"margin-left":"auto"}
}
const _hoisted_31 = { class: "text-light" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_34 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Secondary Actions"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ban" }, null, -1))
const _hoisted_36 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Primary Actions"
}
const _hoisted_37 = ["disabled"]
const _hoisted_38 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = {
  key: 1,
  class: "fas fa-save"
}

import { computed, onMounted, ref, watch, inject } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { useToast } from "vue-toastification";
import { Customer, Office } from "@/models";
import { sortCustomerList } from '@/utilities';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();
const hasUnsavedChanges = computed(() => store.getters['customers/hasUnsavedChanges']);
const setCustomer = (customer: Customer) => store.commit('customers/setCustomer', customer);
const addCustomer = async (customer: Customer) => await store.dispatch('customers/addCustomer', customer);
const updateCustomer = async (customer: Customer) => await store.dispatch('customers/updateCustomer', customer);
const getCompanyNameOptions = async () => await store.dispatch('customers/getCompanyNameOptions');
const editCustomer = async (customer: Customer) => await store.dispatch('customers/editCustomer', customer);
const getCustomer = async (id: string) => await store.dispatch('customers/getCustomer', id);
const offices = computed(() => store.getters['offices/getOffices']);
const toasted = useToast();

const customers = computed(() => store.getters['customers/list']);
const sortedcustomers = computed(() => sortCustomerList(customers.value));

const isSaving = ref(false);
const unsavedChanges = ref(false);
const zerotonineloaded = ref(false);
const customer = ref(new Customer());
const companyNameOptions = ref<string[]>([]);
const branchNameOptions = ref<string[]>([]);
const officeNameOptions = ref<string[]>(offices.value.map((office: Office) => office.name));
const actProperty: any = inject('actProperty');

const getBranchNameOptions = async (companyName?: string) => {
  return await store.dispatch('customers/getBranchNameOptions', companyName);
};
const getOfficesOptions = async () => {
  return await store.dispatch('offices/getOffices');
};

const setUnsavedChanges = (value: boolean) => {
  unsavedChanges.value = value;
};

const saveAll = async () => {
  isSaving.value = true;

  try {
    if (isNewCustomer()) {
      const customerData = await addCustomer(customer.value);
      customer.value = customerData;
      toasted.success(`Saved`);
      router.push(`/customers/${customerData.id}`);
    } else {
      const customerData = await updateCustomer(customer.value);
      customer.value = customerData;
      toasted.success(`Updated`);
    }

    setUnsavedChanges(false);
  } catch (err) {
    isSaving.value = false;
    actProperty.value.displayError(err);
  } finally {
    isSaving.value = false;
  }
};

const cancel = () => {
  // Reload the current route to cancel any changes
  router.go(0);
};

const isNewCustomer = () => {
  return router.currentRoute.value.params.id === 'new';
};

getCompanyNameOptions().then(
  (options: any) => (companyNameOptions.value = options)
);
getBranchNameOptions().then(
  (options: any) => (branchNameOptions.value = options)
);

const init = async () => {
  if(sortedcustomers.value.length === 0) {
    // Load customer with current alphabet
    getCustomersAction({starts_with: customer.value.companyName.charAt(0).toLocaleLowerCase()})
  }
  await getOfficesOptions().then((off: Office[]) => {
    officeNameOptions.value = off.map((office: Office) => office.name);
  });
  if (isNewCustomer()) {
    setCustomer(new Customer());
    return;
  }
  await getCustomer(route.params.id as string)
    .then((cust: Customer) => {
      if (cust === undefined) {
        actProperty.displayError(
          `Could not find customer with ID ${route.params.id as string}`
        );
        router.push({ name: "customerlist" });
      } else {
        customer.value = cust;
        onSelectCompanyName(customer.value.companyName);
      }
    })
    .then(() => {
      setTimeout(() => { store.commit('customers/resetUnsavedChanges'); }, 1000)
    })
    .catch((err: any) => actProperty.displayError(err));
};

onMounted(async () => {
  init();
});

const setCompanyName = (val: string) => {
  customer.value.companyName = val;
  customer.value.branchName = '';
  onSelectCompanyName(val);
  setUnsavedChanges(true);
  editCurrentCustomer();
};

const addCompanyName = (val: string) => {
  companyNameOptions.value.unshift(val);
  setCompanyName(val);
  editCurrentCustomer();
};

const setBranchName = (val: string) => {
  customer.value.branchName = val;
  setUnsavedChanges(true);
  editCurrentCustomer();
};

const onSelectCompanyName = async (companyName: string) => {
  if (companyName) {
    branchNameOptions.value = [];
    branchNameOptions.value = await getBranchNameOptions(companyName);
  }
};

const addBranchName = (val: string) => {
  branchNameOptions.value.unshift(val);
  setBranchName(val);
  editCurrentCustomer();
};
const editCurrentCustomer = () => {
  editCustomer(customer.value);
};

const customerOffice = computed({
  get: () => {
    const office = offices.value.find((office: any) => office.id === customer.value.office);
    return office ? office.name : undefined;
  },
  set: (val: string) => {
    const office: Office | undefined = offices.value.find((office) => office.name === val);
    if (office) {
      customer.value.office = office.id;
      setUnsavedChanges(true);
      editCurrentCustomer();
    }
  }
});

watch(() => router.currentRoute.value.params.id, async (val, oldVal) => {
  if (val != undefined && val !== oldVal) {
    init();
  }
});

const getCustomersAction = async (payload?: { starts_with?: string }) => {
  try {
    await store.dispatch('customers/getCustomers', payload);
  } catch (err: any) {
    actProperty.displayError(err)
  }
};

const previouscustomer = async () => {
  if(customer.value.id) {
    const index = sortedcustomers.value.findIndex((c) => c.id === customer.value.id);
    if (index > 0) {
      router.push({ name: "customer", params: { id: sortedcustomers.value[index - 1].id } });
    }
    else if (index == 0 || index == -1) {
      var alpha = customer.value.companyName.charAt(0).toLocaleLowerCase();
      const links = [
        'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm',
        'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
        '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'
      ];
      const linkindex = links.findIndex((a) => a === alpha);
      if(linkindex > 0 && linkindex <= 25) {
        zerotonineloaded.value = false;
        await getCustomersAction({starts_with: links[linkindex - 1]})
        if(customers.value.length > 0)
          router.push({ name: "customer", params: { id: sortedcustomers.value[sortedcustomers.value.length - 1].id } });
        else
          toasted.warning(`Previous list is empty!`);
      }
      else if(linkindex > 25 && linkindex <= 35 && !zerotonineloaded.value) {
        await  getCustomersAction({starts_with: '0-9'});
        zerotonineloaded.value = true;
        if(customers.value.length > 0)
          router.push({ name: "customer", params: { id: sortedcustomers.value[sortedcustomers.value.length - 1].id } });
        else
          toasted.warning(`Previous list is empty!`);
      }
      else {
        toasted.warning(`You have reached end of line!`);
      }
    }
  }
}

const nextcustomer = async () => {
  if(customer.value.id) {
    const index = sortedcustomers.value.findIndex((c) => c.id === customer.value.id);
    if (index >= 0 && index < sortedcustomers.value.length - 1) {
      router.push({ name: "customer", params: { id: sortedcustomers.value[index+1].id } });
    }
    else if (index == sortedcustomers.value.length - 1) {
      var alpha = customer.value.companyName.charAt(0).toLocaleLowerCase();
      const links = [
        'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm',
        'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
        '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'
      ];
      const linkindex = links.findIndex((a) => a === alpha);
      if(linkindex <= 25) {
        zerotonineloaded.value = false;
        await getCustomersAction({starts_with: links[linkindex + 1]})
        if(customers.value.length > 0)
          router.push({ name: "customer", params: { id: sortedcustomers.value[0].id } });
        else
          toasted.warning(`Next list is empty!`);
      }
      else if(linkindex <= 35 && !zerotonineloaded.value) {
        await getCustomersAction({starts_with: '0-9'});
        zerotonineloaded.value = true;
        if(customers.value.length > 0)
          router.push({ name: "customer", params: { id: sortedcustomers.value[0].id } });
        else
          toasted.warning(`Next list is empty!`);
      }
      else {
        toasted.warning(`You have reached end of line!`);
      }
    }
  }
}



return (_ctx: any,_cache: any) => {
  const _component_singleselect_text = _resolveComponent("singleselect-text")!
  const _component_multiselect_text = _resolveComponent("multiselect-text")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (isNewCustomer())
          ? (_openBlock(), _createElementBlock("h1", _hoisted_4, "Add Customer"))
          : (_openBlock(), _createElementBlock("h1", _hoisted_5, "Edit Customer"))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (!hasUnsavedChanges.value && !isNewCustomer())
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: "fas fa-arrow-left fa-2x",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (previouscustomer()))
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (!hasUnsavedChanges.value && !isNewCustomer())
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: "fas fa-arrow-right fa-2x",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (nextcustomer()))
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("form", null, [
        _createElementVNode("fieldset", null, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_singleselect_text, {
                modelValue: customerOffice.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((customerOffice).value = $event)),
                options: officeNameOptions.value
              }, null, 8, ["modelValue", "options"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_multiselect_text, {
                modelValue: customer.value.companyName,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((customer.value.companyName) = $event)),
                options: companyNameOptions.value,
                taggable: true,
                onTag: addCompanyName,
                onSelect: setCompanyName
              }, null, 8, ["modelValue", "options"])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_multiselect_text, {
                modelValue: customer.value.branchName,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((customer.value.branchName) = $event)),
                options: branchNameOptions.value,
                taggable: true,
                onTag: addBranchName,
                onSelect: setBranchName,
                disabled: customer.value.companyName.length < 1
              }, null, 8, ["modelValue", "options", "disabled"])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("ul", _hoisted_19, [
        _createElementVNode("li", _hoisted_20, [
          _createVNode(_component_router_link, {
            to: "address",
            class: "nav-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Address ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_21, [
          _createVNode(_component_router_link, {
            to: "account",
            class: "nav-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" QC Rules ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_22, [
          _createVNode(_component_router_link, {
            to: "pricelist",
            class: "nav-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Price List ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_23, [
          _createVNode(_component_router_link, {
            to: "establishments",
            class: "nav-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Developments ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_24, [
          _createVNode(_component_router_link, {
            to: "reportsettings",
            class: "nav-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Report Settings ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_25, [
          _createVNode(_component_router_link, {
            to: "logisticsrule",
            class: "nav-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Logistics Rules ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_26, [
          _createVNode(_component_router_link, {
            to: "depository",
            class: "nav-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Depositary ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_27, [
          _createVNode(_component_router_link, {
            to: "fixflo",
            class: "nav-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Fixflo ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_component_router_view, {
      key: _ctx.$route.name,
      style: {"padding-bottom":"60px"}
    })),
    _createElementVNode("nav", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            (hasUnsavedChanges.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_32, "You have unsaved changes"))
              : (_openBlock(), _createElementBlock("span", _hoisted_33, "No unsaved changes")),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn btn-outline-light", { disabled: !hasUnsavedChanges.value }]),
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (cancel()), ["prevent"]))
              }, [
                _hoisted_35,
                _createTextVNode(" Cancel ")
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn btn-light", { disabled: !hasUnsavedChanges.value }]),
                onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (saveAll()), ["prevent"])),
                disabled: !hasUnsavedChanges.value || isSaving.value
              }, [
                (isSaving.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, _hoisted_40))
                  : (_openBlock(), _createElementBlock("i", _hoisted_41)),
                _createTextVNode(" Save ")
              ], 10, _hoisted_37)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})